function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.122 17L0.600071 17C0.240022 17 0 16.7599 0 16.3999L0 3.1982C0 2.83815 0.240038 2.59813 0.600071 2.59813H5.40069L3.60046 4.99845H2.4003L2.4003 14.5997L13.2017 14.5997V13.3995L15.602 10.9992V16.3999C15.602 16.76 15.362 17 15.122 17V17ZM10.9214 3.79827C7.32095 3.79827 4.44059 5.95855 4.80062 9.55903C5.04066 11.8393 6.2408 12.1994 7.20094 12.9195C6.24082 10.8792 7.80101 7.63877 11.5215 7.39875C11.6415 7.39875 11.8815 7.39875 12.0016 7.39875L12.0016 10.9992L18.0023 5.59852L12.0016 0.197811V3.79829H10.9214L10.9214 3.79827Z",
  fill: "#009C63"
});
const SvgRebaseIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 17,
  viewBox: "0 0 19 17",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRebaseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rebase-icon.a1cfda59.svg";
export { ForwardRef as ReactComponent };